import React from "react";
import env from "env";
import { useRouter, SiteLink } from "components";
import { useGet, usePost } from "components";
import { Button, ErrorMessage } from "components";
import { ErrorPopup } from "components";
import utils from "utils";

export function WarrantyView(props) {
  const { query } = useRouter();
  const get = useGet();

  const warrantyId = query.id || "";

  React.useEffect(() => {
    get.send(env.apiBase + `/api/warrantyAdmin/getRegistration/${warrantyId}`);
    // eslint-disable-next-line
  }, []);

  if (get.loading()) {
    return <div>Loading...</div>;
  } else if (get.hasErrors()) {
    return <ErrorPopup title="Loading Error" errors={get.errors} />;
  }

  console.log(get);
  const data = get.response;

  return <Warranty data={data} warrantyId={warrantyId} />;
}

function Warranty({ data }) {
  return (
    <div>
      <h1>Warranty Registration</h1>
      <div style={{ margin: "1rem 0" }}>
        <SiteLink to="/admin/warranty"> &lt; Back to list</SiteLink>
      </div>
      <div className="row">
        <div className="col-md-6">
          <Fld name="First Name" value={data.firstName} />
          <Fld name="Last Name" value={data.lastName} />
          <Fld name="Email" value={data.email} />
          <Fld name="Dob" value={data.dob} />
          <Fld name="Mobile" value={data.mobile} />
          <Fld name="Country" value={data.country} />
          <Fld name="Postcode" value={data.postcode} />
          <Fld name="Model Number" value={data.modelNumber} />
          <Fld name="Purchase Date" value={data.purchaseDate} />
          <Fld name="Where To Buy" value={data.whereToBuy} />
          <Fld name="Newsletter" value={data.newsletter} />
          <Fld name="Interests" value={(data.interests || []).join("\n")} />

          {/* </div>public List<string> Attachments { get; set; } */}
        </div>
        <div className="col-md-6">
          <Fld name="Date Registered" value={utils.date.formatYYYYMMDD(data.dateRegistered)} />
          <div className="row">
            <div className="col-md-3">Receipts:</div>
            <div className="col-md-9">
              {data.fileAttachments &&
                data.fileAttachments.map((file, index) => (
                  <div key={index}>
                    <a href={`${env.apiBase}/api/warrantyAdmin/getFile?file=${encodeURIComponent(file.filePath)}`} target="_blank" rel="noopener noreferrer">
                      {file.fileName}
                    </a>
                  </div>
                ))}
            </div>
          </div>

          <hr />
          <h4 style={{ fontWeight: "bold", marginTop: "1.5rem" }}>Mailchimp integration</h4>

          <Fld name="Status" value={data.mailchimpStatus === 1 ? "Sent" : data.mailchimpStatus === 99 ? "Error" : "N/A"} />
          <Fld name="Date sent" value={utils.date.formatYYYYMMDD(data.mailchimpDateSent)} />
          {data.mailchimpStatus === 99 && <Fld name="Error Message" value={data.mailchimpMessage} />}
          <ResendMailchimp id={data.warrantyRegistrationId} />
        </div>
      </div>
    </div>
  );
}

function Fld({ name, value }) {
  return (
    <div className="row">
      <div className="col-md-3">{name}:</div>
      <div className="col-md-9" style={{ whiteSpace: "pre-line" }}>
        {value}
      </div>
    </div>
  );
}

function ResendMailchimp({ id }) {
  const post = usePost();

  function resend(e) {
    post.send(env.apiBase + "/api/warrantyAdmin/resendMc", { warrantyRegistrationId: id });
  }

  if (post.done()) {
    return window.location.reload();
  }

  return (
    <div>
      <Button onClick={resend} status={post.status}>
        Re-send
      </Button>
      <ErrorMessage errors={post.errors} />
    </div>
  );
}
